import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import Error404 from '../Components/Pages/ErrorPages/ErrorPage404'

const LayoutRoutes = () => {

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {routes.map(({ path, Component }, i) => (
          <Route key={i} path={path} element={Component} />
        ))}
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default LayoutRoutes;
